<template>
	<Modal title="Privacy policy">
		<VueMarkdown class="privacy-policy" :source="policy" />
		<template v-slot:footer>
			<button
				class="btn btn-light"
				@click="$emit('ga-denied')"
			>No</button>
			<button
				class="btn btn-light"
				@click="$emit('ga-allowed')"
			>Yes</button>
		</template>
	</Modal>
</template>

<script>
export default {
	data() {
		return {
			policy: ""
		};
	},
	async created() {
		let p = await fetch("privacy.md");
		this.policy = await p.text();
	}
};
</script>